import React from "react";
import FooterData from '../components/Footer/FooterData';
import Footer from "../components/Footer/Footer";

const NotFound = () => (
    <div className="body_wrapper">
        <section className="error_two_area">
            <div className="container flex">
                <div className="error_content_two text-center">
                    <img src={require("../img/new/error.png")} alt=""/>
                    <h2>Error. We can’t find the page you’re looking for.</h2>
                    <p>
                        Sorry for the inconvenience. Go to our GreenHubLK homepage.
                    </p>
                    <a href="/" className="about_btn btn_hover">
                        Back to Home Page <i className="arrow_right"/>
                    </a>
                </div>
            </div>
        </section>
        <Footer FooterData={FooterData}/>
    </div>
);
export default NotFound;
